import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import DownloadIcon from "@icons/myicons/document-file-download.svg?react";
import LockIcon from "@icons/myicons/lock.svg?react";
import { createObjectUrl, downloadFile } from "@helpers/files";
import { useDownloadBookings } from "@api/v1/hooks/useBookings";
import { useDownloadInvestments } from "@api/v1/hooks/useInvestments";
import { useMyself } from "@api/v1/hooks/useMyself";
import { NonProContainer } from "@components";

export const ExportButton = ({
  activeTab,
  params,
  fullWidth,
}: {
  activeTab?: string;
  fullWidth?: boolean;
  params: {
    accountId: number[];
    minDate: string;
    maxDate: string;
    includeHistoric: boolean;
  };
}) => {
  const { t } = useTranslation();
  const { accountId, minDate, maxDate, includeHistoric } = params;
  const { data: myself } = useMyself();
  const isPlusUser = !!myself?.isUserPlus;

  const { mutate: downloadBookings } = useDownloadBookings(
    { format: "csv", accountId, minDate, maxDate },
    {
      onSuccess: (data) => {
        const url = createObjectUrl(data, "text/csv");
        downloadFile(url, "buchungen.csv");
      },
    }
  );
  const { mutate: downloadInvestments } = useDownloadInvestments(
    {
      format: "csv",
      includeHistoric,
      accountId,
    },
    {
      onSuccess: (data) => {
        const url = createObjectUrl(data, "text/csv");
        downloadFile(url, "investments.csv");
      },
    }
  );

  return (
    <NonProContainer isLockIconShown={false}>
      <Button
        size="small"
        variant={isPlusUser ? "outlined" : "tertiary"}
        fullWidth={fullWidth}
        startIcon={
          isPlusUser ? (
            <DownloadIcon width="20px" height="20px" />
          ) : (
            <LockIcon width="20px" height="20px" />
          )
        }
        onClick={
          isPlusUser
            ? activeTab === "bookings"
              ? downloadBookings
              : downloadInvestments
            : undefined
        }
        sx={{
          userSelect: "none",
          cursor: isPlusUser ? "pointer" : "not-allowed",
        }}
      >
        {t("components.depotsStatistic.tabs.export")}
      </Button>
    </NonProContainer>
  );
};
